import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getNetworkState, NetworkError, networkInitialState, NetworkStatuses } from 'store/network';
import { TTopCategory } from 'data';
import { CatalogueDataState } from './types';
import { sliceKey as name } from './utils';

const initialState: CatalogueDataState = {
	data: [],
	network: networkInitialState,
};

export const CatalogueDataSlice = createSlice({
	name,
	initialState,
	reducers: {
		fetchTopCategoriesRequest(state) {
			state.network = getNetworkState(NetworkStatuses.REQUEST);
		},
		fetchTopCategoriesSuccess(state, action: PayloadAction<{ data: TTopCategory[] }>) {
			const { data } = action.payload;
			state.data = data;
			state.network = getNetworkState(NetworkStatuses.SUCCESS);
		},
		fetchTopCategoriesFailed(state, action: PayloadAction<{ error: NetworkError }>) {
			const { error } = action.payload;
			state.network = getNetworkState(NetworkStatuses.FAILED, error);
		},
	},
});

export const {
	actions: catalogueActions,
	reducer: catalogueReducer,
	name: catalogueName,
} = CatalogueDataSlice;

export const {
	fetchTopCategoriesRequest,
	fetchTopCategoriesFailed,
	fetchTopCategoriesSuccess,
} = catalogueActions;

export const catalogueInitialState = initialState;
